import { render } from "./AcademiesListComponent.vue?vue&type=template&id=e75b4b2a"
import script from "./AcademiesListComponent.vue?vue&type=script&lang=js"
export * from "./AcademiesListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__